module.exports = __webpack_public_path__ + "img/ic-2.ddb5713.svg";